import {createActions} from 'client/framework';

export default createActions(null, ['CLEAR_GUESS', 'LOAD_GUESS', 'UPDATE_QUESTION']);
